import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';
import SectionHeading from '@/components/feature/SectionHeading';
import MovieCard from '@/components/feature/MovieCard';

interface TopicRowProps {
  title: string;
  subtitle: string;
  items: ContentItem[];
  morePath: string;
}

function TopicRow({ title, subtitle, items, morePath }: TopicRowProps) {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <SectionHeading title={title} subtitle={subtitle} morePath={morePath} />
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-5">
        {items.map((item) => (
          <MovieCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}

interface TopicSectionsProps {
  weeklySeries: ContentItem[];
  classicMovies: ContentItem[];
  hotVariety: ContentItem[];
}

export default function TopicSections({
  weeklySeries,
  classicMovies,
  hotVariety,
}: TopicSectionsProps) {
  return (
    <div className="bg-background-50">
      <div className="w-full">
        <TopicRow
          title="本周热播剧集"
          subtitle="近期更新最勤、讨论度最高的剧集精选"
          items={weeklySeries}
          morePath="/category/电视剧"
        />
        <div className="w-full px-4 md:px-8">
          <div className="h-px w-full bg-background-200" />
        </div>
        <TopicRow
          title="经典电影合集"
          subtitle="口碑与热度兼具的银幕佳作"
          items={classicMovies}
          morePath="/category/电影"
        />
        <div className="w-full px-4 md:px-8">
          <div className="h-px w-full bg-background-200" />
        </div>
        <TopicRow
          title="爆款综艺专区"
          subtitle="音乐、竞技、生活，一次看个够"
          items={hotVariety}
          morePath="/category/综艺"
        />
      </div>
      <div className="w-full px-4 md:px-8 pb-6">
        <Link
          to="/search"
          className="flex items-center justify-center gap-2 w-full py-4 rounded-lg bg-primary-50 text-primary-700 text-sm font-medium hover:bg-primary-100 transition-colors cursor-pointer"
        >
          <i className="ri-search-2-line text-lg" />
          没找到想看的？前往搜索页发现更多影视
        </Link>
      </div>
    </div>
  );
}